import { z } from "zod";

const ReasonSchema = z.object({
    id: z.string(),
    reason_name: z.string(),
    reason_name_eng: z.string(),
});

export const reasonApiSchema = {
    reason: ReasonSchema,
};
